import config from './app.constants';
import authenticationService from "../services/authentication.service";
import {Route, RouteProps} from "react-router-dom";
import React from "react";
import OAuth2Service from 'app/services/OAuth2.service';
export interface PrivateRouteProps extends RouteProps  {
    component: any;
}
const PrivateRoute = (props: PrivateRouteProps) : any=> {
    let { component, ...rest } = props;
    const Component = component;

    if (config.enableOAuth2) {
      return (
        <Route {...rest} render={ props => {
          if (OAuth2Service.checkForUserAuthSync()) {
            authenticationService.getAccountInfo();
            return <Component {...props} />
          } else {
            if (config.environment === 'local') {
              authenticationService.OAuth2Login(rest);
            } else {
              const uri = `${config.loginUrl}`;// no need pass id as won't redirect back to app
              window.location.href = uri;
              return null;
            }
          }
          return null;
        }}
        />
      );
    }


    return (
        <Route {...rest} render={ props => {
            authenticationService.login();
            if (localStorage.getItem('token') !== null) {
                authenticationService.getAccountInfo();
                return <Component {...props} />
            } else {
                authenticationService.logout();
            }
            var uri = `${config.loginUrl}?appId=${config.connectAppId}&redirectURL=${config.redirectUrl}${props.location.pathname}`;
            window.location.href = uri;
            return null;
        }}
        />
    );
}
export default PrivateRoute
